import i18next from 'i18next';

i18next.addResources('es_CL', 'UpsellingModal', {
  title: '¿Olvidaste agregar un producto?',
  subtitle: 'Descuida, te sugerimos algunos para complementar tu pedido',
  button: 'No, gracias'
});
